export const formatISODateForInput = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based in JS
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export const formatDate = (date: string | Date | undefined, format: 'dd-MM' | 'dd-MM-yyyy' = 'dd-MM-yyyy'): string => {
  if (!date) return 'N/A';
  
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj.getTime())) return 'Invalid Date';
    
    return dateObj.toLocaleDateString('nl-BE', format === 'dd-MM' ? {
      day: '2-digit',
      month: '2-digit'
    } : {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};


const formatOptionsByType: Record<'deadline' | 'added', Intl.DateTimeFormatOptions> = {
  deadline: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  },
  added: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  },
};

export const calculateDaysDifference = (
  typeCalculation: 'deadline' | 'added',
  fromDate: string
): string | null => {
  if (!fromDate) return null;

  const parsedDate = new Date(fromDate);
  if (Number.isNaN(parsedDate.getTime())) return null;

  return parsedDate.toLocaleDateString('nl-BE', formatOptionsByType[typeCalculation]);
};


export function isDatePast(dateString: string): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of the day
    const date = new Date(dateString);
    return date < today;
  }
  
